import { render, staticRenderFns } from "./ContactsRegistered.vue?vue&type=template&id=e1d0f40e"
import script from "./ContactsRegistered.vue?vue&type=script&lang=js"
export * from "./ContactsRegistered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports